import React from "react";
import { Paper, Box, Typography, LinearProgress, Skeleton } from "@mui/material";

// Tarjeta de métrica. Si recibe `total` muestra porcentaje y barra de progreso.
export const OrigenCard = ({ titulo, valor, total, hex, Icon, selected, onClick, loading }) => {
  const porcentaje = total ? Math.round((valor / total) * 100) : null;
  const clickeable = Boolean(onClick);

  return (
    <Paper
      elevation={0}
      onClick={onClick}
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid",
        borderColor: selected ? hex : "#e0e0e0",
        borderLeft: `4px solid ${hex}`,
        bgcolor: selected ? `${hex}14` : "#fff",
        cursor: clickeable ? "pointer" : "default",
        transition: "box-shadow 0.15s ease, background-color 0.15s ease",
        "&:hover": clickeable ? { boxShadow: "0 2px 8px rgba(60,64,67,0.15)" } : {},
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
        <Typography variant="body2" sx={{ color: "#5f6368", fontWeight: 500 }}>
          {titulo}
        </Typography>
        {Icon && (
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              bgcolor: `${hex}1f`,
              color: hex,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Icon fontSize="small" />
          </Box>
        )}
      </Box>

      {loading ? (
        <Skeleton variant="text" width="60%" height={40} />
      ) : (
        <Box sx={{ display: "flex", alignItems: "baseline", gap: 1 }}>
          <Typography variant="h4" fontWeight={600} sx={{ color: "#202124", lineHeight: 1.1 }}>
            {valor.toLocaleString("es-AR")}
          </Typography>
          <Typography variant="body2" sx={{ color: "#9aa0a6" }}>
            {porcentaje !== null ? `${porcentaje}%` : "pedidos"}
          </Typography>
        </Box>
      )}

      {porcentaje !== null && (
        <LinearProgress
          variant="determinate"
          value={loading ? 0 : porcentaje}
          sx={{
            mt: 1.5,
            height: 6,
            borderRadius: 3,
            bgcolor: "#f1f3f4",
            "& .MuiLinearProgress-bar": { bgcolor: hex, borderRadius: 3 },
          }}
        />
      )}
    </Paper>
  );
};
